import type { UserRole } from "../types";

export type WikiPageStatus = "draft" | "published" | "archived";
export type WikiContentFormat = "markdown" | "mdx" | "structured";
export type WikiVisibility =
  | "all_staff"
  | "admin_only"
  | "roles"
  | "departments"
  | "hidden";

export interface WikiPage {
  id: string;
  title: string;
  slug: string;
  parentId?: string | null;
  order: number;
  content: string;
  contentFormat: WikiContentFormat;
  tags: string[];
  category?: string;
  visibility: WikiVisibility;
  allowedRoles: UserRole[];
  allowedDepartments: string[];
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
  status: WikiPageStatus;
}

export interface WikiPageSummary {
  id: string;
  title: string;
  slug: string;
  parentId?: string | null;
  order: number;
  tags: string[];
  category?: string;
  visibility: WikiVisibility;
  allowedRoles: UserRole[];
  allowedDepartments: string[];
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
  status: WikiPageStatus;
}

export interface WikiPageTreeNode extends WikiPageSummary {
  children: WikiPageTreeNode[];
}

export interface WikiPageUpsertInput {
  title: string;
  slug?: string;
  parentId?: string | null;
  order?: number;
  content?: string;
  contentFormat?: WikiContentFormat;
  tags?: string[];
  category?: string;
  visibility?: WikiVisibility;
  allowedRoles?: UserRole[];
  allowedDepartments?: string[];
  status?: WikiPageStatus;
}

export interface WikiSearchResult extends WikiPageSummary {
  excerpt: string;
}

export interface WikiImportPageDraft {
  id?: string;
  title: string;
  slug: string;
  parentSlug?: string | null;
  content: string;
  contentFormat: WikiContentFormat;
  tags?: string[];
  category?: string;
  visibility?: WikiVisibility;
  allowedRoles?: UserRole[];
  allowedDepartments?: string[];
  status?: WikiPageStatus;
  assets?: Array<{
    sourcePath: string;
    targetPath: string;
  }>;
}

export const WIKI_STATUS_OPTIONS: Array<{ value: WikiPageStatus; label: string }> = [
  { value: "draft", label: "Draft" },
  { value: "published", label: "Published" },
  { value: "archived", label: "Archived" },
];

export const WIKI_VISIBILITY_OPTIONS: Array<{ value: WikiVisibility; label: string }> = [
  { value: "all_staff", label: "All Staff" },
  { value: "admin_only", label: "Admin Only" },
  { value: "roles", label: "By Role" },
  { value: "departments", label: "By Department" },
  { value: "hidden", label: "Hidden" },
];
